import { useState } from "react";
import { useAuth } from "./security/Authcontext";
import { addTodoApi } from "./api/TodoApiService";
import { useNavigate } from "react-router-dom";
import "./AddTodoComponent.css";

function TodoAddUpdateComponent() {
  const navigate = useNavigate();
  const [description, setDescription] = useState("");
  const [targetDate, setTargetDate] = useState("");
  const authContext = useAuth();
  const username = authContext.usrname;

  async function handleSubmit(e) {
    e.preventDefault();

    const newTodo = {
      username,
      description,
      targetDate,
      done: false
    };

    await addTodoApi(username, newTodo, authContext.token);
    navigate("/list-todos");
  }

  return (
    <div className="todo-form-page">
      <div className="todo-card">
        <h1>Add Task</h1>
        <p className="subtitle">Create a new task to stay productive</p>

        <form onSubmit={handleSubmit}>
          <label>Description</label>
          <input
            type="text"
            placeholder="What do you want to do?"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          <label>Target Date</label>
          <input
            type="date"
            value={targetDate}
            onChange={(e) => setTargetDate(e.target.value)}
            required
          />

          <button type="submit">Add Task</button>
        </form>
      </div>
    </div>
  );
}

export default TodoAddUpdateComponent;
